import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";

function QuickQuoteAgent({ agentData, rerender, backgroundColor }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    DOB: "",
    email: "",
    streetAddress: "",
    cityAddress: "",
    zipAddress: "",
    stateAddress: "",
    vehiclesBody: "",
    driversBody: "",
    quoteNotes: "",
    chosenAgent: "",
    address: "",
    dec1: "",
    dec2: "",
    dec3: "",
    name: "",
    notes: "",
    consumerConsent: true,
    dob: "",
    telephone: "",
    quickAddress: "",
    refAgentTwo: ""
  });

  useEffect(() => {
    console.log("Quick Quote Agent Tool Mounted");
    console.log("Props:");
    console.log({ agentData, rerender, backgroundColor });
    setFormData((prev) => ({
      ...prev,
      chosenAgent: agentData._id
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler1 = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({ ...prev, dec1: res }));
      });
    }
  };

  const fileSelectedHandler2 = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({ ...prev, dec2: res }));
      });
    }
  };

  const fileSelectedHandler3 = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({ ...prev, dec3: res }));
      });
    }
  };

  const handleQuoteSubmit = (event) => {
    event.preventDefault();

    const documents = [formData.dec1, formData.dec2, formData.dec3].filter((doc) => doc.length > 0);

    API.saveAgentProspectSubmission(agentData._id, {
      name: formData.name,
      dob: formData.dob,
      address: formData.address,
      email: formData.email,
      telephone: formData.telephone,
      referreeID: "61cbd89ddf3ae329f85d2c42",
      referrerID: agentData._id,
      referee: "evan",
      quoter: "randy",
      documents: documents,
      notes: formData.notes
    })
      .then((_res) => {
        alert("Quote Saved!");
        rerender();
      })
      .catch((err) => console.log(err));

    setTimeout(() => {
      rerender();
    }, 1000);

    API.saveAgentQuoteRequest(agentData._id, {
      firstName: formData.firstName,
      lastName: formData.lastName,
      dob: formData.dob,
      referrerID: agentData._id,
      quickAddress: formData.quickAddress,
      notes: formData.quoteNotes,
      mainAgent: formData.chosenAgent,
      refAgentOne: agentData._id,
      refAgentOneName: agentData.firstName + " " + agentData.lastName,
      refAgentTwo: formData.refAgentTwo
    })
      .then((_res) => {
        alert("Quote Saved!");
        rerender();
      })
      .catch((err) => console.log(err));

    setTimeout(() => {
      rerender();
    }, 1000);
  };

  return (
    <div>
      <div className="card" style={{ backgroundColor: backgroundColor }}>
        <form style={{ padding: "10px" }}>
          <div className="row">
            <div className="col-6">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                value={formData.name}
                onChange={handleInputChange}
                name="name"
                placeholder="Name"
              />
            </div>
            <div className="col-6">
              <label>Date of Birth </label>
              <input
                type="date"
                className="form-control"
                value={formData.dob}
                onChange={handleInputChange}
                name="dob"
              />
            </div>
          </div>
          <hr />
          <div className="form-row row">
            <div className="col-md-6 offset-md-3">
              <label>Referring Agent</label>
              <div>
                <p>
                  {agentData.firstName} {agentData.lastName}
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <label>Email</label>
              <input
                type="text"
                className="form-control"
                value={formData.email}
                onChange={handleInputChange}
                name="email"
                placeholder="e-mail"
              />
            </div>
            <div className="col-6">
              <label>Phone</label>
              <input
                type="text"
                className="form-control"
                value={formData.telephone}
                onChange={handleInputChange}
                name="telephone"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="col-lg-12">
              <label>Client Address</label>
              <input
                type="text"
                className="form-control"
                value={formData.address}
                onChange={handleInputChange}
                name="address"
                id="inputAddress"
                placeholder="Address"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-12">
              <label>Additional Notes</label>
              <textarea
                value={formData.notes}
                onChange={handleInputChange}
                name="notes"
                className="form-control"
                rows="2"
                cols="60"
                placeholder="Notes go here!"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6 offset-2">
              <label>Client consent to running consumer reports?</label>
            </div>
            <div className="col-6 offset-3" style={{ float: "left" }}>
              <input
                type="checkbox"
                checked={formData.consumerConsent}
                onChange={handleInputChange}
                name="consumerConsent"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <label>Declarations I</label>
              <input name="fileData1" type="file" onChange={fileSelectedHandler1} />
            </div>
            <div className="col-md-4">
              <label>Declarations II</label>
              <input name="fileData2" type="file" onChange={fileSelectedHandler2} />
            </div>
            <div className="col-md-4">
              <label>Declarations III</label>
              <input name="fileData3" type="file" onChange={fileSelectedHandler3} />
            </div>
          </div>
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <button className="btn btn-primary" onClick={handleQuoteSubmit}>
              Submit Quote
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default QuickQuoteAgent;
